import { storeToRefs } from 'pinia';
import { computed } from 'vue';
import { Profile } from '@ilteducation/profile-types';
import useMyProfileStore from './my-profile';

const useMyProfiles = () => {
  const store = useMyProfileStore();
  const { current, profiles, isLoading } = storeToRefs(store);
  const { load, create, update, remove, getById, reset } = store;

  const setCurrentById = (profileId: string): void => {
    current.value = profiles.value[profileId] as Profile;
  };

  const clearCurrent = (): void => {
    current.value = undefined;
  };

  const loadAndSelectFirst = async (context: string) => {
    await load(context);
    const firstProfile = Object.values(profiles.value).find((profile) => !!profile);
    if (firstProfile) {
      current.value = firstProfile;
    }
  };

  return {
    current,
    setCurrentById,
    clearCurrent,
    profiles: computed(() => Object.values(profiles.value).filter((profile) => profile !== null) as Profile[]),
    isLoading,
    getById,
    load,
    loadAndSelectFirst,
    create,
    update,
    remove,
    reset,
  };
};

export default useMyProfiles;
